<template>
  <div class="app-tariff-option-box">
    <TariffOptionCancelModal v-if="optionActive"
                             :option="option"
                             ref="cancelModal"
                             :gotBackendErrorInitiate.sync="gotBackendErrorCancel"
    >
      <template v-for="(index, name) in $slots" v-slot:[name]>
        <slot :name="name"></slot>
      </template>
    </TariffOptionCancelModal>
    <TariffOptionRevokeModal v-if="optionActive"
                             :option="option"
                             ref="revokeModal"
                             :gotBackendErrorInitiate.sync="gotBackendErrorCancel"
    >
      <template v-for="(index, name) in $slots" v-slot:[name]>
        <slot :name="name"></slot>
      </template>
    </TariffOptionRevokeModal>
    <TariffOptionNotBookableModal v-if="!optionActive"
                                  :option="option"
                                  ref="notBookableModal"
                                  :gotBackendErrorInitiate.sync="gotBackendErrorCancel"
    >
      <template v-for="(index, name) in $slots" v-slot:[name]>
        <slot :name="name"></slot>
      </template>
    </TariffOptionNotBookableModal>
    <SimonModal
      :id="modalId"
      :is-visible="showModal"
      @hide="showModal = false"
      @shown="loadCountries()"
      custom-modal-class="tariffModal"
      show-footer-buttons
      :btn-right-title="getSlotText('btnBookOptionModal', 'Mach ma!')"
      :disabled-btn-right="loading"
      @btnRight="bookOption"
      @btnLeft="showModal = false"
      size="large"
      :show-accordion="getSlotText('txtLegalModal', '').length > 0"
      :accordion-title="getSlotText('lblLegalModal', 'Rechtliche Hinweise')"
      close-button-color="light"
      sticky-header
    >
      <template v-slot:modalTitle>
        <div class="box-head-left">
          <div class="box-head-title">
            <h4>{{ option.name }}</h4></div>
          <div class="box-head-data"><h4>{{ formattedIncentive }}</h4></div>
        </div>
        <div class="box-head-right">
          <div class="box-head-price">
            <span>{{ formattedPrice }}</span>
          </div>
          <div class="box-head-price-data">
            <span class="price--cur">&euro;</span>
            <span class="price--period">
          <slot name="txtPeriodAbo" v-if="option.automaticExtension">monatlich</slot>
          <slot name="txtPeriodOnetime" v-else>einmal</slot>
        </span>
          </div>
        </div>
      </template>
      <div class="option-modal">
        <div class="option-modal--body">
          <div class="info">
            <dyn-slot :slot-data="slotData"><slot name="txtInfoModal"></slot></dyn-slot>
            <div v-if="isRoamingDataTarif">
              <InputAutocomplete
                :data="getRoamingCountries"
                :placeholder="getSlotText('txtCountrySearchPlaceholder')"
                object-key-name="country"
                :not-found-input-msg="roamingCountryLocation === 'unavailable' ? getSlotText('txtCountryNotListed') : (roamingCountryLocation === 'europe' ? getSlotText('txtCountryEuList') : null)"
                :success-msg="roamingCountryLocation === 'exists' ? getSlotText('txtCountryRoamingList') : null"
                @selectedItemChange="findCountryLocation($event)"
                :show-success-icon="!isCountryInEU"
              />
            </div>
            <dyn-slot :slot-data="slotData"><slot name="txtExtraInfoModal"></slot></dyn-slot>
          </div>
          <div v-if="showContractCancelledInfo" class="cancelled-info">
            <slot name="txtCancelledInfoModal">Cancelled Info</slot>
          </div>
          <div v-if="showDocument !== false" class="contract-summary">
            <slot name="lblContractSummaryPreModal">ContractSummaryPre</slot>&nbsp;
            <span class="download-link" @click="downloadDocumentWithAuth" ><slot name="lblContractSummaryModal">ContractSummary</slot></span>&nbsp;
            <slot name="lblContractSummaryPostModal">ContractSummaryPost</slot>
          </div>
          <div class="kwk-bonus-info d-flex align-items-center justify-content-center" v-if="isModalDataTarif">
            <div class="banner-icon mb-0 mr-3"><slot name="imgInfoModalTariffOptionsGBAboKWK"/></div>
            <div class="banner-text mb-0">
              <slot name="txtInfoModalTariffOptionsGBAboKWK"/>
              <span class="ml-1"></span>
              <slot name="btnInfoModalTariffOptionsGBAboKWK"/>
            </div>
          </div>
        </div>
        <div v-if="gotBackendError" v-html="getBackendErrorMessage" class="error-box"></div>
      </div>
      <template v-slot:accordionText>
        <dyn-slot :slot-data="slotData"><slot name="txtLegalModal"></slot></dyn-slot>
      </template>
    </SimonModal>
    <SimonModal
      :is-visible="changeInfoModal"
      @hide="changeInfoModal = false"
      custom-modal-class="tariffOptionBoxChangeInfoModal"
    >
      <template v-slot:modalTitle>
        <slot name="txtChangeInfoModalHeaderModal"></slot>
      </template>
      <slot name="txtChangeInfoModal">Wechsel Info</slot>
    </SimonModal>

    <div class="tarif-box-details">
      <div class="box-head">
        <div class="box-ribbon" v-if="optionActive || getSlotText('lblOptionRibbon') !== ''">
          <span v-if="optionActive && disabled_"><slot name="lblOptionPaused">Pausiert</slot></span>
          <span v-else-if="optionActive"><slot name="lblOptionActive">Aktiv</slot></span>
          <span v-else-if="getSlotText('lblOptionRibbon') !== ''"><slot name="lblOptionRibbon">Für kurze Zeit</slot></span>
        </div>
        <div class="box-head-left">
          <div class="box-head-title">
            <h4>{{ option.name }}</h4></div>
          <div class="box-head-data"><h4>{{ formattedIncentive }}</h4></div>
        </div>
        <div class="box-head-right">
          <div class="box-head-price">
            <div v-if="birthdayPromo && option.tariffoptionId === '3036138'" class="price--promo">6,00</div>
            <span>{{ formattedPrice }}</span>
          </div>
          <div class="box-head-price-data">
            <span class="price--cur">&euro;</span>
            <span class="price--period">
          <slot name="txtPeriodAbo" v-if="option.automaticExtension">monatlich</slot>
          <slot name="txtPeriodOnetime" v-else>einmal</slot>
        </span>
          </div>
        </div>
      </div>
      <div class="box-body">
        <dyn-slot :slot-data="slotData"><slot name="txtDetail">Detail Info TariffOption</slot></dyn-slot>

        <div v-if="gotBackendError2 || gotBackendErrorCancel" v-html="beErrorGetLastMessage()" class="error-box"></div>
        <div v-if="option.disabledInfo !== null && option.disabledInfo !== '' && !optionActive" class="disabled-info">
          {{ option.disabledInfo }}
        </div>
        <div class="status-info status-info-line" v-if="showProgressInfo"><slot name="txtProgressInfo">Geht erst gleich</slot></div>
        <div class="status-info status-info-line" v-else-if="showCancelledInfo"><dyn-slot :slot-data="slotData"><slot name="txtCancelledInfoExpirationDate">Läuft bis zum {{slotData.expirationDate}}</slot></dyn-slot></div>
        <a class="status-info-line status-change link" @click="showChangeModal()" v-if="optionActive && !revocable">
          <slot name="txtSwitchOption">Wechseln?</slot>
        </a>
      </div>
      <div v-if="!(showContractCancelledInfo && optionActive) && !showProgressInfo" class="tarif-box-cta">
        <button :disabled="disabled_ && !optionActive" @click="initializeOption">
          <slot v-if="!bookable" name="btnNotBookable">Nicht Buchbar</slot>
          <slot v-else-if="optionActive && !revocable" name="btnCancel">Wech damit!</slot>
          <slot v-else-if="revocable" name="btnRevoke">Kündigung widerrufen!</slot>
          <slot v-else name="btnInfo">Sach mir mehr!</slot>
        </button>
      </div>
    </div>
  </div>
</template>
<script>

import price from '@/mixins/formatters/price'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import transaction from '@/mixins/transaction'
import beErrors from '@/mixins/beErrors'
import { mapActions, mapGetters } from 'vuex'
import syncProperty from '@/mixins/syncProperty'
import urlParam from '@/mixins/urlParam'
import axios from 'axios'
import customerContractState from '@/mixins/customerContractState'
import TariffOptionCancelModal from '@/components/process/generic/Tariff/TariffOptionCancelModal.vue'
import TariffOptionRevokeModal from '@/components/process/generic/Tariff/TariffOptionRevokeModal.vue'
import FileSaver from 'file-saver'
import appFileSaver from '@/mixins/appFileSaver'
import TariffOptionNotBookableModal from './TariffOptionNotBookableModal.vue'
import SimonModal from '@/components/modal/SimonModal.vue'
import InputAutocomplete from '@/components/generic/InputAutocomplete.vue'
import useFeature from '@/mixins/useFeature'

export default {
  name: 'TariffOptionBox',
  components: {
    InputAutocomplete,
    SimonModal,
    TariffOptionNotBookableModal,
    TariffOptionCancelModal,
    TariffOptionRevokeModal
  },
  data () {
    return {
      showModal: false,
      changeInfoModal: false,
      showDocument: false,
      errorMsg: false,
      gotBackendError: false,
      gotBackendError2: false,
      gotBackendErrorCancel: false,
      initializeOptionStarted: false,
      loading: false,
      roamingCountryLocation: null,
      isCountryInEU: false
    }
  },
  methods: {
    ...mapActions('tariffOptions', [
      'bookTariffoption',
      'confirmBookTariffoption',
      'loadRoamingCountries'
    ]),
    async loadCountries () {
      if (this.isRoamingDataTarif) {
        await this.loadRoamingCountries()
      }
    },
    bookOption () {
      this.gotBackendError = false
      this.gotBackendError2 = false
      this.loading = true
      this.startLoader()

      return new Promise((resolve) => {
        this.confirmBookTariffoption({})
          .then((response) => {
            if (response.success === true) {
              this.showModal = false
              this.loading = false
              this.successToast(this.$slots.txtBookTariffOptionSuccess
                ? this.$slots.txtBookTariffOptionSuccess[0].text
                : 'Die Option wurde erfolgreich gebucht. In kurzer Zeit wird diese auch im Kundenportal angezeigt.'
              )
              this.$emit('refetch-tariff-options')
              this.gotBackendError = false
              this.errorMsg = ''
              this.trackOption('confirmation')
            }
            resolve()
          })
          .catch(() => {
            this.showModal = true
            this.gotBackendError = true
            this.loading = false
            this.triggerErrorTracking()
            resolve()
          })
          .finally(() => this.stopLoader())
      })
    },
    async initializeOption () {
      if (!this.bookable) {
        this.$refs.notBookableModal.initializeNotBookableOption()
        return
      } else if (this.optionActive && !this.revocable) {
        this.$refs.cancelModal.initializeCancelOption()
        return
      } else if (this.revocable) {
        this.$refs.revokeModal.initializeRevokeOption()
        return
      }

      if (this.initializeOptionStarted || !this.bookable || this.disabled) return

      this.gotBackendError = false
      this.gotBackendError2 = false
      this.initializeOptionStarted = true
      this.startLoader()

      try {
        const response = await this.bookTariffoption({ tariffoptionId: this.option.tariffoptionId })

        if (response.success) {
          this.showDocument = response.bookTariffoptionDocumentUrl || false
          this.showModal = true
          this.gotBackendError2 = false
          this.trackOption('summary')
        }
      } catch (error) {
        this.showModal = false
        this.gotBackendError2 = true
        this.triggerErrorTracking()
      } finally {
        this.initializeOptionStarted = false
        this.stopLoader()
      }
    },
    downloadDocumentWithAuth (e) {
      if (e.preventDefault) e.preventDefault()
      if (e.stopPropagation) e.stopPropagation()
      const me = this
      this.errorMsg = false

      axios.get(this.showDocument, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/octet-stream'
        },
        responseType: 'blob'
      }).then((response) => {
        const filename = 'Vertragszusammenfassung.pdf'
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        if (this.appTriggerSaveAsFileAvailable()) {
          this.appTriggerSaveAsFile(filename, file)
        } else {
          FileSaver.saveAs(file, filename)
        }
      }).catch((reason) => {
        this.errorMsg = this.getSlotText('errorNoContractDocumentAvailable', 'Ufff! Leider kann dat Dokument gerade nicht geladen werden (Fehler: VD1). Bitte probier\'s später noch einmal.')
        this.gotBackendError = true
        this.loading = false
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    },
    trackOption (stepName) {
      let pageLevels = []
      if (this.inOverview) {
        pageLevels = [
          'mein-simon',
          'uebersicht',
          'option booking',
          stepName
        ]
      } else {
        pageLevels = [
          'mein-simon',
          'service',
          'option booking',
          stepName
        ]
      }
      const data = {
        page_levels: pageLevels,
        login_status: 'logged in',
        page_type: 'self service',
        platform_type: 'browser view',
        form: {
          name: 'option booking',
          step: stepName === 'summary' ? '1' : '2',
          step_name: stepName,
          type: 'ecare'
        },
        propositions: [{
          name: this.option.name + ' ' + this.formattedIncentive,
          audience: 'consumer',
          type: 'option',
          line: 'data',
          category: 'option',
          items: [{
            id: this.option.tariffoptionId,
            name: this.option.name + ' ' + this.formattedIncentive,
            type: 'service',
            price_once: !this.option.automaticExtension ? this.option.price : 0,
            price_monthly: this.option.automaticExtension ? this.option.price : 0,
            duration: 1,
            units: 1
          }]
        }]
      }
      if (stepName === 'confirmation') {
        data.form.status = 'success'
        data.order_id = this.processId
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', data)
      }
    },
    triggerErrorTracking () {
      const errMsg = this.getBackendErrorMessage
      if (errMsg !== null) {
        const data = {
          type: 'technical',
          message: errMsg.substring(0, 50),
          code: String(this.beErrorGetLastErrorCode())
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      }
    },
    showChangeModal () {
      this.changeInfoModal = true
    },
    findCountryLocation (selectedCountry) {
      const isInRoamingCountries = this.getRoamingCountries.some(country => country.country === selectedCountry)
      const isInEURoamingCountries = this.getEURoamingCountries.some(country => country.country === selectedCountry)
      if (isInEURoamingCountries) {
        this.roamingCountryLocation = 'europe'
        this.isCountryInEU = true
      } else if (isInRoamingCountries) {
        this.roamingCountryLocation = 'exists'
        this.isCountryInEU = false
      } else {
        this.roamingCountryLocation = 'unavailable'
        this.isCountryInEU = false
      }
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    ...mapGetters('tariffOptions', [
      'processId',
      'getRoamingCountries',
      'getEURoamingCountries'
    ]),
    isModalDataTarif () {
      return this.option.group === 'data'
    },
    isRoamingDataTarif () {
      // Select Travel-Data 1GB Tarif
      return this.option.tariffoptionId === '3050138'
    },
    getBackendErrorMessage: function () {
      if (this.errorMsg !== false) {
        return this.errorMsg
      }
      return this.beErrorGetLastMessage()
    },
    slotData () {
      let endOfRuntime = ''
      if (this.option.activeRuntime !== undefined && this.option.activeRuntime.endOfRuntime !== undefined) {
        endOfRuntime = this.dateFormatter(new Date(this.option.activeRuntime.endOfRuntime))
      }
      let expirationDate = ''
      if (this.option.expirationDate !== undefined) {
        expirationDate = this.dateFormatter(new Date(this.option.expirationDate))
      }
      const data = {
        price: this.formattedPrice + ' €',
        formattedIncentive: this.formattedIncentive,
        incentive: this.incentive,
        endOfRuntime,
        expirationDate
      }
      return data
    },
    formattedPrice () {
      return this.formatDecimal(this.option.price / 100, 2) || '0,00'
    },
    formattedIncentive () {
      return this.incentive
    },
    incentive () {
      return this.option.volumes[0].amount + ' ' + this.option.volumes[0].formattedUnit
    },
    showContractCancelledInfo () {
      return (this.option.automaticExtension && this.contractDismissedInFuture)
    },
    showProgressInfo () {
      return (this.option.statusKey !== undefined && ['IDL', 'PDL'].includes(this.option.statusKey))
    },
    showCancelledInfo () {
      return (this.option.statusKey !== undefined && ['CAN', 'TER'].includes(this.option.statusKey))
    },
    optionActive () {
      /**
       IDL: in delivery, not yet available to the customer
       PDL: partly delivered, not completely available to the customer
       CDL: completely delivered, product is active for the customer
       TER: terminated, no longer available to the customer
       SUS: suspended, option currently in sleeping state, possibly due to lack of credit
       CAN: cancelled, user has requested the cancellation of the option
       RET: revoked, user has withdrawn the option, before it became active
       */
      return (this.option.statusKey !== undefined && ['CDL', 'CAN', 'TER'].includes(this.option.statusKey))
    },
    revocable () {
      if (this.option.statusKey !== undefined && this.option.statusKey === 'CAN') {
        return (this.option.revocable !== null && this.option.revocable)
      }
      return false
    },
    modalId () {
      return this.option.name + '_' + this.option.volumes[0].amount + '' + this.option.volumes[0].formattedUnit
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bookable: {
      type: Boolean,
      default: true
    },
    inOverview: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    syncProperty('disabled', 'disabled_'),
    beErrors,
    price,
    formatDecimal,
    dateFormatter,
    transaction('tariffOptions'),
    customerContractState(),
    appFileSaver,
    urlParam,
    useFeature('birthdayPromo')
  ],
  mounted () {
    const hash = this.getURLParam('modal')
    if (hash === this.modalId) {
      this.initializeOption()
      history.replaceState(null, null, window.location.pathname)
    }
  }
}
</script>
